module.exports = __webpack_public_path__ + "media/images/accordion-collapse-76017c22efbe04324757903f81f548b3.svg";